import axios from "axios";

import { DOMAIN } from "../config";

const Axios = axios.create({
  baseURL: `//${DOMAIN}`,
  withCredentials: true
});

// 不重定向接口
export const ExcpetRedirectAxios = axios.create({
  baseURL: `//${DOMAIN}`,
  withCredentials: true
});

Axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (403 === error.response.status) {
      window.location = `//${getDomain()}/signin?dest=${window.location}`;
    } else {
      return Promise.reject(error);
    }
  }
);

export default Axios;

export function getCookie(name) {
  const cookies = document.cookie;
  const list = cookies.split("; ");

  for (let i = 0; i < list.length; i += 1) {
    const arr = list[i].split("=");
    if (arr[0] === name) {
      return arr[1];
    }
  }
  return null;
}

export function setCookie(name, value) {
  document.cookie = name + "=" + value;
}

export function getDomain() {
  const parts = window.location.hostname.split(".");
  const sndleveldomain = parts.slice(-2).join(".");
  return sndleveldomain;
}
